var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "theme-editor" },
    [
      _c(
        "router-link",
        { staticClass: "btn btnAccent mb-3", attrs: { to: "/Venue-List" } },
        [_vm._v("Back to Venues")]
      ),
      _c(
        "div",
        { staticClass: "tab-row" },
        _vm._l(_vm.screens, function (screen) {
          return _c(
            "button",
            {
              key: screen,
              class: ["tab-btn", { active: screen === _vm.activeScreen }],
              on: {
                click: function ($event) {
                  _vm.activeScreen = screen
                },
              },
            },
            [_vm._v(" " + _vm._s(screen) + " ")]
          )
        }),
        0
      ),
      _c("div", { staticClass: "customize-card" }, [
        _c("div", { staticClass: "customize-header" }, [
          _c("h2", [
            _vm._v("Customize Colors "),
            _c(
              "button",
              {
                staticClass: "tooltip-btn",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.imageInfo()
                  },
                },
              },
              [_c("span", { staticClass: "question-mark" }, [_vm._v("?")])]
            ),
          ]),
        ]),
        _c("div", { staticClass: "customize-body" }, [
          _c("div", { staticStyle: { "margin-bottom": "16px" } }, [
            _c("div", { staticClass: "theme-dropdown" }, [
              _c(
                "label",
                {
                  staticClass: "dropdown-label",
                  attrs: { for: "theme-select" },
                },
                [_vm._v("Select a Theme")]
              ),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedThemeName,
                      expression: "selectedThemeName",
                    },
                  ],
                  staticClass: "dropdown-select",
                  attrs: { id: "theme-select" },
                  on: {
                    change: [
                      function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selectedThemeName = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                      _vm.applyPreset,
                    ],
                  },
                },
                _vm._l(_vm.themePresets, function (preset) {
                  return _c(
                    "option",
                    { key: preset.name, domProps: { value: preset.name } },
                    [_vm._v(" " + _vm._s(preset.name) + " ")]
                  )
                }),
                0
              ),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "color-grid" },
            _vm._l(_vm.visibleTheme, function (entry, key) {
              return _c("div", { key: key, staticClass: "color-input" }, [
                _c("label", { attrs: { for: key } }, [
                  _vm._v(_vm._s(_vm.formatLabel(key))),
                ]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.theme[key].value,
                      expression: "theme[key].value",
                    },
                  ],
                  staticClass: "color-picker",
                  attrs: { type: "color", id: key },
                  domProps: { value: _vm.theme[key].value },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.theme[key], "value", $event.target.value)
                    },
                  },
                }),
              ])
            }),
            0
          ),
          _c(
            "button",
            {
              staticClass: "btn btnAccent mt-2",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.saveVenue()
                },
              },
            },
            [_vm._v("Submit")]
          ),
        ]),
      ]),
      _c(_vm.getComponent(_vm.activeScreen), {
        tag: "component",
        style: { backgroundColor: _vm.theme.screenBackgroundColor.value },
        attrs: { theme: _vm.theme, venue: _vm.venueHold },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }